import colors from "../../base/colors";
import typography from "../../base/typography";
import borders from "../../base/borders";
import pxToRem from "../../functions/pxToRem";

const { info, inputBorderColor, dark, grey } = colors;
const { size } = typography;
const { borderWidth, borderRadius } = borders;

const input = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: dark.main,
      backgroundColor: `${grey[100]}` ,
      borderRadius: borderRadius.sm,
      paddingTop: pxToRem(4),
      paddingLeft: pxToRem(4),
      paddingRight: pxToRem(4),
      
      "&:inputMultiline":{
        whiteSpace:"pre",
      },

      "&:selected": {
        color: dark.main,
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
      },

      "&:before": {
        borderColor: inputBorderColor,
      },
      textarea: {
        whiteSpace: "pre",
        resize: "none"//"both",
      },

      "&:after": {
        borderColor: info.main,
      },
    },
  },
};

export default input;
